export enum UserType {
    DRIVER = 1,
    WELCOME_TEAM_OFFICER,
    MANAGER,
    HR,
    ADMIN,
    KLINIK,
}

export enum UserExtras {
    DEFAULT = 0,
    SHIFT_WITHOUT_VEHICLE = 2 ** 0, // make shift operations without vehicle (with buttons)
}

export type UserLifeCycle = {
    startedAt: string;
    leavedAt: string;
    createdAt: string;
    updatedAt: string;
    driverId?: string;
    id: string;
};

export type User = {
    identityNumber: string;
    id: string;
    dbId: string;
    driverId?: string;
    userType: UserType;
    userName: string;
    name: string;
    email: string;
    permissionGroups: PermissionGroup[];
    isDeleted?: boolean;
    disabled?: boolean;
    vehicleData?: Vehicle;
    updatedAt?: string | null;
    lifecycles: UserLifeCycle[];
    n2MobileName?: string;
    extras: UserExtras;
};

export type Vehicle = {
    id: string;
    licensePlate: string;
    brand: string;
    model: string;
};

export type PermissionGroup = {
    id?: string;
    name?: string;
    permisssions?: string[]; // Note: Check spelling if you meant "permissions"
};
